import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, TooltipProps } from 'recharts';
import { NameType, ValueType } from "recharts/types/component/DefaultTooltipContent";
import { IKmosV2TimeSlotGraphDataResponse } from "../../../logic/api";

import styles from "./KmosView.module.css";
import { useTranslation } from "react-i18next";

const KmosDialogGraph: React.FunctionComponent<{
  graphData: IKmosV2TimeSlotGraphDataResponse
}> = (props) => {
  const data = props.graphData;
  const { t } = useTranslation()


  const CustomTooltip = ({
    active,
    payload,
  }: TooltipProps<ValueType, NameType>) => {
    if (active && payload) {

      return (
        <div className={styles.graphTooltipContainer}>
          <div className={styles.graphTooltipHeader}>
            <div className={styles.graphTooltipDate}>{payload[0].payload.date}</div>
          </div>
          <div className={styles.graphTooltipDataRow}>
            <div className={styles.graphTooltipDataRowName}>{payload[2].name}: </div>
            <div className={styles.graphTooltipDataRowValue} style={{ color: "#0366D6" }}>{payload[2].value}</div>
          </div>
          <div className={styles.graphTooltipDataRow}>
            <div className={styles.graphTooltipDataRowName}>{payload[1].name}: </div>
            <div className={styles.graphTooltipDataRowValue} style={{ color: "#34D059" }}>{payload[1].value}</div>
          </div>
          <div className={styles.graphTooltipDataRow}>
            <div className={styles.graphTooltipDataRowName}>{payload[0].name}: </div>
            <div className={styles.graphTooltipDataRowValue} style={{ color: "#8A8D8F" }}>{payload[0].value}</div>
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <BarChart
      barCategoryGap={"15%"}
      height={100}
      width={640}
      data={data.graphData}
      margin={{
        top: 5,
        right: 30,
        left: -20,
        bottom: 0,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="date" />
      <YAxis />
      <Tooltip content={<CustomTooltip />} />
      <Bar dataKey="parked" stackId="a" fill="#8A8D8F" name={t("kmos.labels.parked")} />
      <Bar dataKey="arrived" stackId="a" fill="#34D059" name={t("kmos.labels.arrived")} />
      <Bar dataKey="due_in" stackId="a" fill="#0366D6" name={t("kmos.labels.dueIn")} />
    </BarChart>
  );
};

export default KmosDialogGraph;
